import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=485f11e0&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=485f11e0&prod&scoped=true&lang=css&"
import style1 from "./Messages.vue?vue&type=style&index=1&id=485f11e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f11e0",
  null
  
)

export default component.exports